import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";

class SelecterenDirectievoerder extends React.Component {
  constructor(props) {
    super(props);
    this.state = { directievoerder: "", directievoerderText: "" };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    var index = event.nativeEvent.target.selectedIndex;

    this.setState({
      directievoerder: event.target.value,
      directievoerderText: event.nativeEvent.target[index].text,
    });
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);
    //** save directievoerder
    var directievoerderModel = {
      directievoerder: {
        identification: this.state.directievoerder,
        display: [
          {
            path: "$.alias",
            value: this.state.directievoerderText,
          },
        ],
      },
    };
    await GC.StartActivity(
      directievoerderModel,
      [window.$catalog_work_plans_selectedIds],
      "0f2c4cd8-bd15-48d9-b66b-6292ace8881f",
      this.submitCallback,
      window.$catalog_management_units_token
    );
  }
  submitCallback() {
    GC.sleep(1000).then(() => {
      $("#selecteren_directievoerder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }
  async componentDidMount() {
    $("#selecteren_directievoerder").on(
      "show.bs.modal",
      async function (event) {
        //** get user managers
        let directievoerders = await omnimap.GetUserByRoleAction(
          1,
          6,
          "Directievoerder",
          window.$catalog_management_units_token
        );
        await CallBackFunctions.DirectievoerderCallbackForCreate(
          directievoerders.data
        );
      }
    );
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="selecteren_directievoerder"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Selecteren directievoerder</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //**Werkplan directievoerder(manager) */}
                <label>Selecteren directievoerder </label>
                <select
                  class="form-control"
                  id="werkplan-directievoerder"
                  name="directievoerder"
                  value={this.state.directievoerder}
                  onChange={this.handleInputChange}
                ></select>

                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplann"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelecterenDirectievoerder;
